export const formatPlaybackTime = (value) => {
  const seconds = Number.isFinite(Number(value))
    ? Math.max(0, Math.floor(Number(value)))
    : 0;
  const hours = Math.floor(seconds / 3600);
  const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
  const remainder = String(seconds % 60).padStart(2, "0");
  return hours ? `${hours}:${minutes}:${remainder}` : `${minutes}:${remainder}`;
};

export const isPlayerShortcut = (event, player) => {
  if (
    !player ||
    (player.isDisposed && player.isDisposed()) ||
    event.defaultPrevented ||
    event.altKey ||
    event.ctrlKey ||
    event.metaKey
  )
    return false;
  const target = event.target;
  // Native controls own their keys. In particular, Space on a button must not
  // also toggle playback through the document handler.
  if (
    target &&
    target.closest &&
    target.closest(
      "input, textarea, select, button, a, [contenteditable='true'], [role='slider']"
    )
  )
    return false;
  const root = player.el();
  if (!root) return false;
  // An outer detail dialog contains the player. Only a dialog *inside* the
  // player (e.g. audio/subtitle options) should suppress player shortcuts.
  const dialog = target && target.closest && target.closest("[role='dialog']");
  if (dialog && root.contains(dialog)) return false;
  if (root.contains(target)) return true;
  return (
    root.classList.contains("vod-player") &&
    (target === document.body || target === document.documentElement)
  );
};

export const seekBy = (player, offset) => {
  if (!player || (player.isDisposed && player.isDisposed())) return;
  const current = player.currentTime();
  if (!Number.isFinite(current)) return;
  const duration = player.duration();
  let start = 0;
  let end = Number.isFinite(duration) ? Math.max(0, duration) : Infinity;
  const seekable = player.seekable && player.seekable();
  if (!Number.isFinite(duration) && seekable && seekable.length) {
    start = seekable.start(0);
    end = seekable.end(seekable.length - 1);
  }
  player.currentTime(Math.max(start, Math.min(end, current + offset)));
};
